import Cookies, {CookieAttributes} from 'js-cookie';

export class CookieHandler {
  readonly domain: string;
  readonly path: string;
  readonly expireTimes: number | Date;
  readonly secure: boolean;


  constructor(expireTimes: number | Date = 58, domain: string = '', path: string = '', secure: boolean = true) {
    this.domain = domain;
    this.path = path;
    this.secure = secure;
    this.expireTimes = expireTimes;
  }

  public set(cookieName: string, cookieValue: string, options: CookieAttributes = this.options()) {
    Cookies.set(cookieName, cookieValue, options);
  }

  public get(cookieName: string): string {
    const result = Cookies.get(cookieName);
    return result ? result : '';
  }

  public remove(cookieName: string) {
    Cookies.remove(cookieName, this.options());
  }

  private options(): CookieAttributes {
    return {
      secure: this.secure,
      expires: this.expireTimes,
      domain: this.domain || '',
      path: this.path || '',
    };
  }
}

